import { draftSavedTime } from './DraftSaveTime.locstring.json';
import loc, { format } from 'owa-localize';
import * as React from 'react';
import { ComposeViewState } from 'owa-mail-compose-store';

import { formatRelativeDate } from 'owa-observable-datetime';
import { observer } from 'mobx-react';

const styles = require('./ComposeBottom.scss');
const classNames = require('classnames/bind').bind(styles);

export interface DraftSaveTimeProps {
    viewState: ComposeViewState;
}

/**
 * Use this component to only draw Draft save time, so that when the time is changed, we don't need to rerender other components
 */
@observer
export default class DraftSaveTime extends React.Component<DraftSaveTimeProps, {}> {
    containerRef: React.RefObject<HTMLDivElement> = React.createRef();

    getWidth() {
        return this.containerRef.current ? this.containerRef.current.clientWidth : 0;
    }

    render() {
        // Use a placeholder here to occupy the space when there isn't an available time string
        // so that we don't need to always do remeasure when draft save time is changed
        const draftSaveTime = this.props.viewState.lastSaveTimeStamp || new Date().toISOString();
        const className = classNames(styles.draftSaveTime, {
            isHidden: this.props.viewState.lastSaveTimeStamp == null,
        });

        const draftSaveTimeString = formatRelativeDate(draftSaveTime);

        return (
            <div ref={this.containerRef} className={className}>
                {draftSaveTimeString && format(loc(draftSavedTime), draftSaveTimeString)}
            </div>
        );
    }
}
